<template>
  <Html lang="en">

    <Head>
      <Title>{{ title }}</Title>
      <!-- <template v-for="link in head.link" :key="link.id">
        <Link :id="link.id" :rel="link.rel" :href="link.href" :hreflang="link.hreflang" />
      </template>
      <template v-for="meta in head.meta" :key="meta.id">
        <Meta :id="meta.id" :property="meta.property" :content="meta.content" />
      </template> -->
    </Head>

    <Body>
      <NuxtLoadingIndicator :color="'#fed400'" :height="4" />
      <Navbar/>
      <Sidebar/>
      <div :data-theme="theme">
        <slot />
      </div>
      <Footer/>
    </Body>
  </Html>
</template>

<script setup>
const route = useRoute();
const title = computed(() => t('Cantas.id', { title: t(route.meta.title ?? 'TBD') }));

// const THEMES = [
//   'light',
//   'dark',
// ];
const theme = ref(null);
const isLoading = ref(true);
watch(theme, (value) => {
  localStorage.setItem('daisyui-theme', value);
});
onMounted(() => {
  theme.value = localStorage.getItem('daisyui-theme') || 'light';
});
</script>
